import React from "react";

export default function ProductSummaryCard() {
  return (
    <>
      <div className="psc-wrap">
        <div className="psc-card psc-main-card">
          <h3>Résumé documentaire</h3>

          <div className="psc-source-pill">Base de conformité pays source</div>

          <div className="psc-big-title">SON MANCÀP</div>
          <div className="psc-small">NP : TJO2323J</div>

          <div className="psc-row">
            <span>Date d'enfissent</span>
            <strong>02.04.2024</strong>
          </div>

          <div className="psc-row">
            <span>Expiration</span>
            <strong>02.04.2027</strong>
          </div>

          <div className="psc-valid-pill">
            <span className="psc-valid-dot">●</span>
            <span>Dossier valide</span>
          </div>
        </div>

        <div className="psc-card psc-small-card">
          <div className="psc-missing-line">
            <span>Documents manquants :</span>
            <span className="psc-missing-value">Aucun</span>
          </div>

          <div className="psc-actions">
            <button>Voir les pièces</button>
            <button className="psc-small-action">S ▸ ▾</button>
          </div>
        </div>

        <div className="psc-empty-card"></div>
      </div>

      <style>{`
        .psc-wrap {
          display: flex;
          flex-direction: column;
          gap: 14px;
        }

        .psc-card,
        .psc-empty-card {
          border-radius: 14px;
          background: linear-gradient(180deg, rgba(28,38,73,0.96), rgba(20,28,55,0.96));
          border: 1px solid rgba(255,255,255,0.07);
          box-shadow: 0 14px 32px rgba(0,0,0,0.24);
        }

        .psc-card {
          padding: 16px 18px;
        }

        .psc-empty-card {
          min-height: 165px;
          background: linear-gradient(180deg, rgba(28,38,73,0.82), rgba(20,28,55,0.82));
        }

        .psc-main-card h3 {
          margin: 0 0 16px;
          color: #f2f6ff;
          font-size: 18px;
          font-weight: 500;
          line-height: 1.25;
        }

        .psc-source-pill {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          min-height: 36px;
          padding: 0 14px;
          border-radius: 9px;
          background: rgba(88,141,118,0.18);
          border: 1px solid rgba(88,141,118,0.26);
          color: #ecfff2;
          font-size: 14px;
          margin-bottom: 18px;
        }

        .psc-big-title {
          color: #ffffff;
          font-size: 24px;
          font-weight: 500;
          line-height: 1.15;
          margin-bottom: 4px;
        }

        .psc-small {
          color: #b5c0df;
          font-size: 14px;
          margin-bottom: 18px;
        }

        .psc-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 12px;
          padding: 10px 0;
          color: #d8e2ff;
          font-size: 14px;
          border-bottom: 1px solid rgba(255,255,255,0.06);
        }

        .psc-row strong {
          color: #f3f7ff;
          font-size: 14px;
          font-weight: 700;
        }

        .psc-valid-pill {
          margin-top: 16px;
          min-height: 42px;
          border-radius: 9px;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          background: rgba(88,141,118,0.20);
          border: 1px solid rgba(88,141,118,0.28);
          color: #ecfff2;
          font-size: 15px;
          font-weight: 500;
        }

        .psc-valid-dot {
          color: #d8f7de;
          font-size: 13px;
          line-height: 1;
        }

        .psc-small-card {
          padding-top: 14px;
          padding-bottom: 14px;
        }

        .psc-missing-line {
          display: flex;
          align-items: center;
          gap: 6px;
          flex-wrap: wrap;
          color: #e3e9ff;
          font-size: 15px;
          margin-bottom: 14px;
        }

        .psc-missing-value {
          color: #9eaad0;
        }

        .psc-actions {
          display: flex;
          gap: 8px;
        }

        .psc-actions button {
          flex: 1;
          height: 40px;
          border-radius: 10px;
          border: 1px solid rgba(255,255,255,0.08);
          background: rgba(255,255,255,0.04);
          color: #edf3ff;
          font-size: 14px;
          cursor: pointer;
        }

        .psc-small-action {
          max-width: 118px;
        }

        @media (max-width: 760px) {
          .psc-main-card h3 {
            font-size: 17px;
          }

          .psc-source-pill {
            font-size: 13px;
          }

          .psc-big-title {
            font-size: 22px;
          }

          .psc-small,
          .psc-row,
          .psc-row strong,
          .psc-missing-line,
          .psc-actions button,
          .psc-valid-pill {
            font-size: 14px;
          }

          .psc-empty-card {
            min-height: 150px;
          }
        }
      `}</style>
    </>
  );
}